var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resume-list",class:{
    'without-padding':
      _vm.metaData &&
      _vm.metaData.subpanels &&
      _vm.metaData.subpanels.panelColumn &&
      _vm.metaData.subpanels.panelColumn.length
  }},[(
      _vm.metaData &&
      _vm.metaData.subpanels &&
      _vm.metaData.subpanels.panelColumn &&
      _vm.metaData.subpanels.panelColumn.length
    )?_c('Subpanel',{staticClass:"resume-list__subpanel",attrs:{"tabs":_vm.metaData.subpanels.panelColumn,"module":"HRPAC_CANDIDATE_RESUME"}}):_c('Alert',{staticClass:"resume-list__alert",attrs:{"text":"Резюме еще не были добавлены. Вы можете добавить их с помощью кнопки «Редактировать»"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }